"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../../Icons/index");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AccordionBoxHeader = function AccordionBoxHeader(_ref) {
  var children = _ref.children,
      open = _ref.open,
      toggle = _ref.toggle,
      rest = _objectWithoutProperties(_ref, ["children", "open", "toggle"]);

  return /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    onClick: toggle
  }, rest), children, /*#__PURE__*/_react.default.createElement(ToggleWrapper, {
    open: open
  }, /*#__PURE__*/_react.default.createElement(_index.IconActionDropDown, null)));
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["position:relative;width:100%;padding-right:6.5rem;cursor:pointer;"]);

var ToggleWrapper = _styledComponents.default.div.withConfig({
  displayName: "ToggleWrapper"
})(["position:absolute;top:50%;right:0;transform:", ";cursor:pointer;transition:transform 0.2s cubic-bezier(0.85,0,0.15,1);svg path{stroke:", ";}"], function (_ref2) {
  var open = _ref2.open;
  return open ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ui.outline;
});

AccordionBoxHeader.propTypes = {
  children: _propTypes.node,
  open: _propTypes.bool,
  toggle: _propTypes.func
};
var _default = AccordionBoxHeader;
exports.default = _default;